import { useState } from 'react';
import useScrollAnimation from '../../../hooks/useScrollAnimation';
import { foodMenuItems } from '../../../mocks/restaurant';

const CARD_WIDTH = 320;
const CARD_GAP = 24;

const MenuSection = () => {
  const { ref: titleRef, animStyle: titleAnim } = useScrollAnimation();
  const [paused, setPaused] = useState(false);

  // Use first 5 items only, duplicated for seamless loop
  const items = foodMenuItems.slice(0, 5);
  const loopItems = [...items, ...items];

  // Total width of one set = 5 cards * (CARD_WIDTH + CARD_GAP)
  const singleSetWidth = items.length * (CARD_WIDTH + CARD_GAP);

  return (
    <section id="menu" className="bg-cream-light py-20 md:py-28">
      <div className="max-w-6xl mx-auto px-5 md:px-10">
        {/* Section Title */}
        <div ref={titleRef} style={titleAnim} className="text-center mb-14">
          <p className="font-sans-jp text-xs tracking-[0.3em] text-teal-deep mb-3 uppercase">
            Menu
          </p>
          <h2 className="font-serif-jp font-bold text-brown-dark text-2xl md:text-3xl tracking-wide mb-4">
            お料理
          </h2>
          <p className="font-sans-jp text-sm text-brown-mid max-w-md mx-auto leading-loose">
            アジア各国の定番料理を、産地を確認したスパイス・食材でご用意しています。価格はすべて税込です。
          </p>
          <div className="flex items-center justify-center gap-3 mt-6">
            <div className="h-px w-10 bg-teal-deep/30" />
            <div className="w-1.5 h-1.5 rounded-full bg-orange-sunset" />
            <div className="h-px w-10 bg-teal-deep/30" />
          </div>
        </div>
      </div>

      {/* Infinite Scroll Carousel */}
      <div
        className="overflow-hidden w-full"
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
      >
        <div
          className="flex"
          style={{
            gap: `${CARD_GAP}px`,
            paddingLeft: `${CARD_GAP}px`,
            width: `${singleSetWidth * 2}px`,
            animation: 'marquee 28s linear infinite',
            animationPlayState: paused ? 'paused' : 'running',
          }}
        >
          {loopItems.map((item, i) => (
            <div
              key={`${item.id}-${i}`}
              className="flex-shrink-0 bg-white rounded-lg overflow-hidden border border-brown-dark/8 hover:border-teal-deep/30 transition-colors group"
              style={{ width: `${CARD_WIDTH}px` }}
            >
              <div
                className="overflow-hidden"
                style={{ width: `${CARD_WIDTH}px`, height: '220px' }}
              >
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  style={{ borderRadius: '4px 4px 0 0' }}
                />
              </div>
              <div className="p-5">
                <div className="flex items-baseline justify-between mb-1">
                  <h3 className="font-serif-jp font-semibold text-brown-dark text-lg leading-snug">
                    {item.name}
                  </h3>
                  <span className="font-sans-jp text-teal-deep font-semibold text-base whitespace-nowrap ml-3">
                    ¥{item.price.toLocaleString()}
                    <span className="text-xs text-brown-light ml-0.5">税込</span>
                  </span>
                </div>
                <p className="font-sans-jp text-xs text-brown-light tracking-wider mb-2">{item.nameEn}</p>
                <p className="font-sans-jp text-xs text-brown-mid leading-relaxed line-clamp-3">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Note */}
      <div className="max-w-6xl mx-auto px-5 md:px-10 mt-10">
        <p className="font-sans-jp text-xs text-brown-light text-center leading-loose">
          ※ メニュー内容・価格は変更になる場合があります。アレルギーをお持ちの方はスタッフへお申し付けください。
        </p>
      </div>
    </section>
  );
};

export default MenuSection;
